import DataGrid, { Column, Lookup } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import React, {
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from "react";
import api from "../../services/api";
import PhotoCell from "./CellRender/PhotoCell";
import { Container, StatusCell } from "./styles";

import { ValueContext } from "../../context/ValueProvider";
import { useToast } from "../../hooks/toast";
import DialogSeniorProject from "../../pages/Evaluation/Seniors/DialogSeniorProject";
import DialogSeniorsMentee from "../../pages/Evaluation/Seniors/DialogSeniorsMentee";
import { useAuth } from "../../hooks/auth";
import pdsGroups from "../../config/pdsGroups";

export default function EvaluationToDos({ path }) {
  const { hasScope, user } = useAuth();
  const { addToast } = useToast();
  const [openEditProject, setOpenEditProject] = useState(false);
  const [openEditMentee, setOpenEditMentee] = useState(false);

  const [projectEditInfo, setProjectEditInfo] = useState([]);
  const [projectEditId, setProjectEditId] = useState(0);
  const [areaTypes, setAreaTypes] = useState([]);
  const { master } = useContext(ValueContext);

  const getAreaTypes = useCallback(async () => {
    const { data } = await api.get(`api/area-types`);

    setAreaTypes(data);
  }, []);

  const [cycles] = useState({
    store: new CustomStore({
      key: "ID",
      loadMode: "raw",
      load: async () => {
        const { data } = await api.get("api/cycles");
        const cyclesWithDisplayName = data.map((cycle) => ({
          ...cycle,
          displayName: `(${cycle.areaType?.description}) ${cycle.period}Q - ${cycle.year}`,
        }));

        return cyclesWithDisplayName.sort(
          (a, b) => b.areaType?.description - a.areaType?.description
        );
      },
    }),
    paginate: true,
  });

  const dataSource = useMemo(() => {
    return new DataSource({
      load: async () => {
        const { data } = await api.get("api/evaluations/todos");
        return data;
      },

      loadMode: "raw",
      cacheRawData: true,
    });
  }, [getAreaTypes]);

  const dataGridRef = useRef(null);

  const handleRowClick = useCallback((e) => {
    if (e.data.isProject) {
      setProjectEditInfo(e.data);
      setProjectEditId(e.data.id);
      setOpenEditProject(true);
    } else {
      setProjectEditInfo(e.data);
      setOpenEditMentee(true);
    }
  }, []);

  const isFilledRender = useCallback((e) => {
    // const isMentorEvaluation = !e.data.isProject;

    // let isLineFilled = false;
    // if ((e.data.isPartner && e.data.fieldValue) || e.data.fieldText) {
    //   isLineFilled = true;
    // }

    // let isMentorFilled = false;
    // if (
    //   e.data.evaluation &&
    //   e.data.evaluation.evaluationSeniorMentees &&
    //   e.data.evaluation.evaluationSeniorMentees.length > 0
    // ) {
    //   const menteeEvaluation = e.data.evaluation.evaluationSeniorMentees.find(
    //     (mentee) => mentee.idMentee === e.data.idEvaluator
    //   );
    //   if (menteeEvaluation?.menteeEvaluation?.trim()) {
    //     isMentorFilled = true;
    //   }
    // }

    // // adição de nova regra no status (se o campo de isNA estiver preenchido, etc)
    // const isNAFilled = e.data.isNA;
    // const isFieldText1Filled = e.data.fieldText?.trim();
    // const isFieldText2Filled = e.data.fieldText2?.trim();

    // let status = "Pending";

    // if (isMentorFilled && isLineFilled) {
    //   status = "Done";
    // } else if (isMentorFilled && !isLineFilled) {
    //   if (isMentorEvaluation) {
    //     status = "Done";
    //   } else {
    //     status = "Pending";
    //   }
    // } else if (!isMentorFilled && isLineFilled) {
    //   status = "Done";
    // }

    // if (isNAFilled && isFieldText1Filled) {
    //   status = "Done";
    // } else if (isFieldText1Filled && !isNAFilled) {
    //   status = "Pending";
    // } else if (isFieldText1Filled && isFieldText2Filled) {
    //   status = "Done";
    // } else if (isFieldText2Filled && isNAFilled) {
    //   status = "Done";
    // } else if (isNAFilled && !isFieldText1Filled) {
    //   status = "Pending";
    // }

    // if (
    //   (e.data.isProject &&
    //     (e.data.isActive !== true || e.data.isApplicable !== true)) ||
    //   (!e.data.isProject &&
    //     (e.data.isApplicable !== true || e.data.doYouFeelComfortable !== true))
    // ) {
    //   status = "N/A";
    // }

    function isFilled(val) {
      return val !== undefined && val !== null && String(val).trim() !== "";
    }

    function getStatus({
      isProject,
      isPartner,
      isActive,
      isApplicable,
      doYouFeelComfortable,
      fieldText,
      fieldValue,
      fieldText2,
      fieldValue2,
      fieldText3,
      menteeEvaluation,
      menteeDevelopmentPoints,
    }) {
      // For type "project", status is N/A if isActive or isApplicable are false
      if (isProject) {
        if (!isActive || !isApplicable) return "N/A";
        return isPartner
          ? isFilled(fieldText) &&
            isFilled(fieldValue) &&
            isFilled(fieldText2) &&
            isFilled(fieldValue2) &&
            isFilled(fieldText3)
            ? "Done"
            : "Pending"
          : isFilled(fieldText) && isFilled(fieldText2) && isFilled(fieldText3)
          ? "Done"
          : "Pending";
      } else {
        // For other types, status is N/A if isApplicable or doYouFeelComfortable are false
        if (doYouFeelComfortable !== null && doYouFeelComfortable === false) {
          return "N/A";
        }

        if (
          doYouFeelComfortable === undefined ||
          (doYouFeelComfortable === true &&
            (!isFilled(menteeEvaluation) || !isFilled(menteeDevelopmentPoints)))
        ) {
          return "Pending";
        }

        if (
          doYouFeelComfortable === true &&
          isFilled(menteeEvaluation) &&
          isFilled(menteeDevelopmentPoints)
        ) {
          return "Done";
        }
      }
    }

    // Example usage:
    const status = getStatus({
      isProject: e.data.isProject, // "project" or other
      isPartner: e.data.isPartner,
      isActive: e.data.isActive,
      isApplicable: e.data.isApplicable,
      doYouFeelComfortable: e.data.doYouFeelComfortable,
      fieldText: e.data.fieldText,
      fieldValue: e.data.fieldValue,
      fieldText2: e.data.fieldText2,
      fieldValue2: e.data.fieldValue2,
      fieldText3: e.data.fieldText3,
      menteeEvaluation: e.data.menteeEvaluation,
      menteeDevelopmentPoints: e.data.menteeDevelopmentPoints,
    });
    return (
      <StatusCell status={status}>
        <PhotoCell data={e.data.professional} />
        {status}
      </StatusCell>
    );
  }, []);

  return (
    <Container>
      <h2
        style={{
          fontWeight: 600,
          marginBottom: "1em",
          fontSize: "1.5rem",
        }}
      >
        Inputs for senior evaluation
      </h2>
      <DataGrid
        key="id"
        dataSource={dataSource}
        ref={dataGridRef}
        height="fit-content"
        headerFilter={{ visible: true, allowSearch: true }}
        onRowClick={handleRowClick}
        columnAutoWidth
        sorting={{ mode: "multiple" }}
        onToolbarPreparing={(e) => {
          e.toolbarOptions.items.unshift({
            location: "after",
            widget: "dxButton",
            options: {
              text: "Clear Filters",
              elementAttr: { class: "clear-filter" },
              icon: "filter",
              onClick: () => {
                e.component.clearFilter();
              },
            },
          });
        }}
      >
        <Column
          dataField="isFilled"
          allowFiltering={true}
          allowSorting={false}
          caption="Status"
          cellRender={isFilledRender}
          width={230}
          alignment="left"
          allowEditing={true}
          calculateFilterExpression={(filterValue, selectedFilterOperation) => {
            return function (data) {
              function isFilled(val) {
                return (
                  val !== undefined && val !== null && String(val).trim() !== ""
                );
              }

              function getStatus(data) {
                const {
                  isProject,
                  isPartner,
                  isActive,
                  isApplicable,
                  doYouFeelComfortable,
                  fieldText,
                  fieldValue,
                  fieldText2,
                  fieldValue2,
                  fieldText3,
                  menteeEvaluation,
                  menteeDevelopmentPoints,
                } = data;

                if (isProject) {
                  if (!isActive || !isApplicable) return "N/A";
                  return isPartner
                    ? isFilled(fieldText) &&
                      isFilled(fieldValue) &&
                      isFilled(fieldText2) &&
                      isFilled(fieldValue2) &&
                      isFilled(fieldText3)
                      ? "Done"
                      : "Pending"
                    : isFilled(fieldText) &&
                      isFilled(fieldText2) &&
                      isFilled(fieldText3)
                    ? "Done"
                    : "Pending";
                } else {
                  if (
                    doYouFeelComfortable !== null &&
                    doYouFeelComfortable === false
                  ) {
                    return "N/A";
                  }

                  if (
                    doYouFeelComfortable === undefined ||
                    (doYouFeelComfortable === true &&
                      (!isFilled(menteeEvaluation) ||
                        !isFilled(menteeDevelopmentPoints)))
                  ) {
                    return "Pending";
                  }

                  if (
                    doYouFeelComfortable === true &&
                    isFilled(menteeEvaluation) &&
                    isFilled(menteeDevelopmentPoints)
                  ) {
                    return "Done";
                  }
                }
              }

              return getStatus(data) === filterValue;
            };
          }}
          headerFilter={{
            dataSource: [
              { text: "Done", value: "Done" },
              { text: "Pending", value: "Pending" },
              { text: "N/A", value: "N/A" },
            ],
          }}
        />
        <Column
          dataField="professional.id"
          caption="Professional"
          alignment="left"
          dataType="number"
          width={130}
          allowSorting={true}
          allowFiltering={true}
          calculateSortValue={(data) => {
            const professional = master?.professionals?.find(
              (p) => p.ID === data.professional.id
            );
            return professional ? professional.Name : "";
          }}
          calculateFilterExpression={(filterValue, selectedFilterOperation) => {
            return function (data) {
              // Se o valor do filtro for um ID (número), comparar diretamente
              if (typeof filterValue === "number" || !isNaN(filterValue)) {
                return data.professional.id === parseInt(filterValue);
              }

              // Se for texto, buscar por nome
              const professional = master?.professionals?.find(
                (p) => p.ID === data.professional.id
              );
              const professionalName = professional ? professional.Name : "";

              return professionalName
                .toLowerCase()
                .includes(filterValue.toLowerCase());
            };
          }}
          headerFilter={{
            dataSource:
              master.professionals
                ?.filter(
                  (prof) =>
                    prof.JobTitle?.Name?.toLowerCase().includes("senior") ||
                    prof.JobTitle?.Name?.toLowerCase().includes("manager") ||
                    prof.JobTitle?.Name?.toLowerCase().includes("director") ||
                    prof.JobTitle?.Name?.toLowerCase().includes("partner")
                )
                .map((prof) => ({
                  text: prof.Name,
                  value: prof.ID,
                })) || [],
            allowSearch: true,
          }}
        >
          <Lookup
            dataSource={master.professionals}
            displayExpr="Name"
            valueExpr="ID"
          />
        </Column>
        <Column
          dataField="idProject"
          caption="Project"
          dataType="number"
          editorType="dxSelectBox"
          cellRender={(e) =>
            e && e.data.projectCode && e.data.projectName
              ? e.data.projectCode
              : ""
          }
        >
          <Lookup
            dataSource={master.projects}
            editorType="dxSelectBox"
            displayExpr={(item) =>
              item && item.ProjectCode && item.ProjectName
                ? `${item.ProjectCode} - ${item.ProjectName}`
                : ""
            }
            valueExpr="ID"
          />
        </Column>
        <Column
          dataField="idEvaluator"
          caption="Evaluator"
          allowSorting={true}
          calculateSortValue={(data) => {
            const professional = master?.professionals?.find(
              (p) => p.ID === data.idEvaluator
            );
            return professional ? professional.Name : "";
          }}
          cellRender={(e) => <PhotoCell data={e.data.evaluator} />}
          defaultFilterValues={hasScope(pdsGroups.Admin) ? [user.userId] : null}
        >
          <Lookup
            dataSource={master.professionals}
            displayExpr="Name"
            valueExpr="ID"
          />
        </Column>

        <Column
          dataField="isProject"
          caption="Project?"
          headerFilter={{
            dataSource: [
              { text: "Yes", value: true },
              { text: "No", value: false },
            ],
          }}
        />
        <Column dataField="isApplicable" caption="Considered?" />
        <Column dataField="doYouFeelComfortable" caption="Feels Comfortable?" />
        <Column
          dataField="evaluation.idCycle"
          caption="Cycle"
          editorType="dxSelectBox"
          cellRender={(e) =>
            `${e.data.evaluation.cycle.period}Q — ${e.data.evaluation.cycle.year}`
          }
        >
          <Lookup
            dataSource={cycles}
            displayExpr="displayName"
            valueExpr="id"
            placeholder="Select cycle"
            searchExpr={["year"]}
            minSearchLength={2}
            required={true}
            showDataBeforeSearch={true}
            searchEnabled={true}
          />
        </Column>
      </DataGrid>
      {openEditProject && (
        <DialogSeniorProject
          evaluationId={projectEditInfo.idEvaluation}
          id={projectEditInfo.id}
          open={openEditProject}
          handleClose={() => setOpenEditProject(false)}
          onChanged={() => dataSource.reload()}
          idAreaType={projectEditInfo?.evaluation?.idAreaType}
        />
      )}
      {openEditMentee && (
        <DialogSeniorsMentee
          handleClose={() => setOpenEditMentee(false)}
          open={openEditMentee}
          statusId={projectEditInfo?.evaluation?.idEvaluationStatus}
          idEvaluation={projectEditInfo.idEvaluation}
          idMentee={projectEditInfo?.idEvaluator}
          onChanged={() => {
            setOpenEditMentee(false);
            dataSource.reload();
          }}
        />
      )}
    </Container>
  );
}
